// extracted by mini-css-extract-plugin
export default {"nodatafound":"chatnodatafound_nodatafound__qiMl8"};